import { Component, OnInit } from '@angular/core';
import { VendorApiItem } from '../../vendors/vendor-landing/vendor-landing.model';
import { AssessmentApiItem } from '../../assessment/assessment-landing/assessment-landing.model';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PaymentModalComponent } from '../payment-modal/payment-modal.component';
import alertify from 'alertifyjs';
import { ApiServiceService } from '../../../modules/services/api-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GenericResponse } from '../../../modules/shared/models/general.modal';
import { LoggedInHeaderComponent } from "../../../components/logged-in-header/logged-in-header.component";

@Component({
  selector: 'app-make-payment-modal',
  imports: [CommonModule, PaymentModalComponent, LoggedInHeaderComponent],
  templateUrl: './make-payment-modal.html',
  styleUrl: './make-payment-modal.scss',
})
export class MakePaymentModal implements OnInit {
  applicationId: string | null;
  payment: {
    vendorName: string,
    categoryName: string,
    amountToPay: string | number,
    applicationId: string
  };
  initiatePaymentProcess: boolean = false;
  isInitiatingPayment: boolean = false;
  timeoutId: number | null = null;

  constructor(
    // private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private apiService: ApiServiceService
  ) {}

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParams;
    const params = this.route.snapshot.params;

    const applicationId = params['id'];
    const applicationType = queryParams['application-type'];

    if (!applicationId || !applicationType) {
      alertify.error("Failed to get application ID or type");
      return;
    }
    
    switch (applicationType) {
      case "VENDOR":
        this.fetchVendorInfo(applicationId);
        break;
      case "ASSESSMENT": 
        // this.fetchAssessmentInfo(applicationId);
        break;
      default:
        alertify.error("Failed to infer application type");
        break;
    }
  }

  fetchVendorInfo(applicationId: string) {
    this.apiService.get(`/vendors/${applicationId}`).subscribe(
      {
        next: (response: GenericResponse<VendorApiItem>) => {
          if (response.status !== "success") throw new Error();
          const vendor = response.data;
          this.payment = {
            vendorName: vendor.name,
            categoryName: vendor.category_name,
            amountToPay: vendor.payment_amount,
            applicationId: vendor.id,
          };
        }, 
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            alertify.error(error.message);
          } else {
            alertify.error(error);
          }
        }
      }
    );
  }

  // fetchAssessmentInfo(applicationId: string) {
  //    this.apiService.get(`/assessments/${applicationId}`).subscribe(
  //     {
  //       next: (response: GenericResponse<AssessmentApiItem>) => {
  //         if (response.status !== "success") throw new Error();
  //         const assessment = response.data;
  //         this.payment = {
  //           vendorName: assessment.Vendor_name,
  //           categoryName: assessment.category_name,
  //           amountToPay: assessment.amount_due,
  //           applicationId: assessment.id
  //         }
  //       }, 
  //       error: (error) => {
  //         if (error instanceof HttpErrorResponse) {
  //           alertify.error(error.message);
  //         } else {
  //           alertify.error(error);
  //         }
  //       }
  //     }
  //   );
  // }

  goBack() {
    // this.router.navigate(["../"], {relativeTo: this.route});
    this.location.back();
  }

  proceedToPayment() {
    this.initiatePaymentProcess = false;
    this.isInitiatingPayment = true;
    console.log("Paying...")
    if (this.timeoutId !== null) clearTimeout(this.timeoutId);

    this.timeoutId = setTimeout(() => {
      this.initiatePaymentProcess = true;
    }, 50);
  }

  onClose() {
    this.initiatePaymentProcess = false
    this.isInitiatingPayment = false;
  }
}
